import React, { useState, useEffect, useContext } from "react";
import { Col } from "react-bootstrap";
import { TextField, InputLabel } from "@mui/material";
import { requestOtpAPI } from "../changePayService/changePayService";
import { toast, ToastContainer } from "react-toastify";
import { StoreContext } from "../../../context/store";
import ContactModal from "../../Component/ContactModal";

const VerifyForm = ({ channelType }) => {
  const [otp, setOtp] = useState("");
  const [openContactModal, setOpenContactModal] = useState(false);
  const { updateInformationEditBank, updateInformationEditPromptPay } =
    useContext(StoreContext);

  const handleOtp = (e) => {
    let otp = e.target.value;
    setOtp(otp);
    let data = {
      otp: otp,
    };
    if (channelType === "bank") {
      updateInformationEditBank(data);
    } else {
      updateInformationEditPromptPay(data);
    }
  };

  const resendOtp = () => {
    handleReqOtp();
  };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("CHANGE_PAY");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  useEffect(() => {
    handleReqOtp();
  }, []);

  return (
    <>
      <label htmlFor="otp">
        กรุณาใส่หมายเลข OTP 6 หลัก ที่ส่งไปยังเบอร์มือถือของท่าน
        (รหัสนี้มีอายุการใช้งาน 5 นาที)
      </label>
      <TextField
        InputProps={{ sx: { borderRadius: 16 }, maxRows: 6 }}
        id="otp"
        type="tel"
        className="mb-2"
        placeholder="OTP"
        variant="outlined"
        // value={informationEditBank.bank_account_name}
        size="small"
        onChange={(e) => handleOtp(e)}
        inputProps={{
          maxLength: 6, 
          inputMode: "numeric", 
          pattern: "[0-9]*"
        }}
        fullWidth
      />
      <div
        style={{
          flex: 1,
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "flex-start", // ✅ ให้ชิดซ้าย
          width: "100%",
          marginTop: 10,
        }}
      >
        <div
          className="font-size-content-otp"
          style={{ fontSize: "14px", textAlign: "left" }} // ✅ กันพลาดเพิ่ม textAlign ด้วย
        >
          ส่งรหัสผ่านไปที่หมายเลข{" "}
          {localStorage.getItem("mobile_tel")
            ? localStorage
                .getItem("mobile_tel")
                .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
            : ""}
        </div>
        <div
          className="font-size-content-otp"
          style={{ fontSize: "14px", textAlign: "left" }}
        >
          กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
        </div>
        <div
          className="font-size-content-otp"
          style={{ fontSize: "14px", textAlign: "left" }}
        >
          กรุณา
          <span
            onClick={() => setOpenContactModal(true)}
            style={{
              color: "#FF5E43",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ติดต่อฝ่ายลูกค้าสัมพันธ์
          </span>
        </div>
      </div>
      <br/>
      <small
        id="emailHelp"
        onClick={resendOtp}
        className="form-text text-primary pointer"
        style={{ cursor: 'pointer' }}
      >
        ส่งรหัส OTP อีกครั้ง?
      </small>

      <ToastContainer />
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
    </>
  );
};

export default VerifyForm;
